<template>
  <div class="search-drawer" :class="showSearchDrawer ? 'active' : ''">
    <p class="top-line clearfix">
      <span>{{ $t("a_search") }}</span>
      <span class="float-right close-search" @click="hideSearchWrapper">
        <i class="el-icon-close"></i>
      </span>
    </p>
    <div class="drawer-body">
      <div class="form-wrapper">
        <el-form
          :model="searchFormData"
          ref="searchForm"
          label-position="top"
          size="mini"
          class="search-form"
        >
          <el-form-item :label="$t('_data.p_name')" prop="search_number">
            <el-input
              v-model="searchFormData.search_number"
              @change="handleAdvanceSearch"
              @keydown.enter.stop="handleAdvanceSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('gender')" prop="search_gender">
            <el-select
              v-model="searchFormData.search_gender"
              @change="handleAdvanceSearch"
              placeholder=" "
            >
              <el-option :label="$t('male')" value="M"></el-option>
              <el-option :label="$t('female')" value="F"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('age')" prop="age">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.search_age_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.search_age_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('project.s_date')">
            <el-date-picker
              v-model="study_date"
              value-format="yyyy-MM-dd"
              type="daterange"
              size="mini"
              :clearable="clearable"
              prefix-icon=" "
              range-separator="-"
              @change="handleAdvanceSearch"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('project.up_time')">
            <el-date-picker
              v-model="create_date"
              value-format="yyyy-MM-dd"
              type="daterange"
              size="mini"
              :clearable="clearable"
              prefix-icon=" "
              range-separator="-"
              @change="handleAdvanceSearch"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('project.modality')">
            <el-select
              v-model="searchFormData.search_modality"
              multiple
              @change="handleAdvanceSearch"
              placeholder=" "
            >
              <el-option
                v-for="(item, index) in modalityOptions"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('_data.series_type')">
            <el-select
              v-model="searchFormData.search_series"
              multiple
              @change="handleAdvanceSearch"
              placeholder=" "
            >
              <el-option
                v-for="(item, index) in seriesOptions"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="block">
            <span class="demonstration">{{ $t("_data.tags") }}</span>
            <el-select
              v-model="searchFormData.search_tag"
              multiple
              size="mini"
              @change="handleAdvanceSearch"
              placeholder=" "
            >
              <el-option
                v-for="(item, index) in searchTagOptions"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 
          <div class="cutting-line py-1 mt-3"></div>

          <el-form-item :label="$t('tags.subject_diagnosis')">
            <el-select
              v-model="searchFormData.diagnosis_tags.diagnosis"
              multiple
              @change="handleAdvanceSearch"
              placeholder=" "
            >
              <el-option
                v-for="(item, index) in diagnosisOptions"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('tags.subject_sideonset')">
            <el-select
              v-model="searchFormData.diagnosis_tags.sideonset"
              multiple
              @change="handleAdvanceSearch"
              placeholder=" "
            >
              <el-option
                v-for="(item, index) in sideonsetOptions"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('tags.subject_staging')">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.hystaging_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.hystaging_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item :label="$t('tags.subject_disease')">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.course_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.course_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="MMSE">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.mmse_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.mmse_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="MOCA">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.moca_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.moca_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="HAMA">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.hama_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.hama_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="HAMD">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.hamd_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.hamd_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="UPDRS-I">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs1_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs1_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="UPDRS-II">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs2_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs2_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="UPDRS-III">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs3_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs3_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="UPDRS-IV">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs4_min"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="searchFormData.diagnosis_tags.updrs4_max"
                  @change="handleAdvanceSearch"
                  @keydown.enter.stop="handleAdvanceSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item :label="$t('tags.education')">
            <el-input
              v-model="searchFormData.diagnosis_tags.education"
              @change="handleAdvanceSearch"
              @keydown.enter.stop="handleAdvanceSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="button-wrapper">
        <button
          type="button"
          class="btn btn-primary btn-sm mr10"
          @click.stop="handleAdvanceSearch"
        >
          {{ $t("a_search") }}
        </button>
        <el-button size="small" @click="resetForm('searchForm')">{{
          $t("project.clear")
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { modalityRequest } from "@/api/api";
export default {
  props: {
    searchFormData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showSearchDrawer: {
      type: Boolean,
      default: false,
    },
    hideSearchWrapper: {
      type: Function,
      default: function () {
        return {};
      },
    },
    handleAdvanceSearch: {
      type: Function,
      default: function () {
        return {};
      },
    },
    diagnosisOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    sideonsetOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    hystagingOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    resetForm: {
      type: Function,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    create_date: {
      get() {
        if (
          this.$store.state.dataParams.search_createdate_min != "" &&
          this.$store.state.dataParams.search_createdate_max != ""
        ) {
          return [
            this.$store.state.dataParams.search_createdate_min,
            this.$store.state.dataParams.search_createdate_max,
          ];
        } else {
          return [];
        }
      },
      set(value) {
        console.log("create_date set", value);
        this.$store.state.dataParams.search_createdate_min = value[0] || "";
        this.$store.state.dataParams.search_createdate_max = value[1] || "";
      },
    },
    study_date: {
      get() {
        if (
          this.$store.state.dataParams.search_studydate_min != "" &&
          this.$store.state.dataParams.search_studydate_max != ""
        ) {
          return [
            this.$store.state.dataParams.search_studydate_min,
            this.$store.state.dataParams.search_studydate_max,
          ];
        } else {
          return [];
        }
      },
      set(value) {
        this.$store.state.dataParams.search_studydate_min = value[0] || "";
        this.$store.state.dataParams.search_studydate_max = value[1] || "";
        console.log("study_date set", value);
      },
    },
  },
  data() {
    return {
      clearable: false,
      modalityOptions: [],
      seriesOptions: [],
      searchTagOptions: [],
      pickerOptions: {
        disabledDate(time) {
          // 限制最大日期为今天（包含今天）
          return time.getTime() > new Date().setHours(23, 59, 59, 999);
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {});
    this.getModalityAndSeries();
  },
  methods: {
    //获取高级搜索模态和序列
    async getModalityAndSeries() {
      try {
        let res = await modalityRequest();
        if (res.status === 200) {
          this.modalityOptions = res.data.data_modality
            ? res.data.data_modality
            : [];
          this.seriesOptions = res.data.data_series ? res.data.data_series : [];
          this.searchTagOptions = res.data.data_tags ? res.data.data_tags : [];
        }
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-drawer {
  padding-bottom: 30px;
  overflow-y: scroll;
  margin-right: 260px;
  .el-form-item--mini.el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item--mini .el-form-item__label {
    line-height: 20px;
  }

  .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }

  .line {
    text-align: center;
  }

  .el-col {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }

  .top-line {
    margin-bottom: 10px;
  }

  .el-select {
    width: 100%;
  }

  .cutting-line {
    margin-bottom: 10px;
    border-top: 1px solid #dddddd;
  }

  .button-wrapper {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #dddddd;
    text-align: center;
  }
}
</style>